import React from 'react';
import { Link } from 'react-router-dom';

const HomeButton = () => {
  const isAdminLoggedIn = localStorage.getItem('adminLoggedIn') === 'true';
  const homePath = isAdminLoggedIn ? '/adminlogin' : '/';

  return (
    <Link to={homePath} className="home-link">Home</Link>
  );
};

export default HomeButton;